"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAgency = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const transformToDate_1 = require("../transformers/transformToDate");
let HostAgency = class HostAgency {
    _id;
    name;
    currency = legacy_enums_1.Currency.Dollar;
    url;
    discountCoefficient;
    commissionPercentage;
    partnerBookingAvailable = false;
    defaultCountryIso;
    ownerId;
    logoUrl;
    type;
    isCommissionHidden = false;
    override = false;
    contracts;
    createdAt = new Date();
    billingDate = 5;
    billingEmails;
    emailDomain;
};
exports.HostAgency = HostAgency;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        return typeof value === "string" ? value.trim() : value;
    }),
    __metadata("design:type", String)
], HostAgency.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], HostAgency.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[a-z0-9\-_]+$/, {
        message: "url should contain only lowercase alphanumeric characters",
    }),
    __metadata("design:type", String)
], HostAgency.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], HostAgency.prototype, "discountCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], HostAgency.prototype, "commissionPercentage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HostAgency.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "defaultCountryIso", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "logoUrl", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, type_graphql_1.Field)(() => String, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.HostAgencyType),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HostAgency.prototype, "isCommissionHidden", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], HostAgency.prototype, "override", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], HostAgency.prototype, "contracts", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Date),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], HostAgency.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(28),
    __metadata("design:type", Number)
], HostAgency.prototype, "billingDate", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEmail)({}, { each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, type_graphql_1.Field)(() => [String], { nullable: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Array)
], HostAgency.prototype, "billingEmails", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/, {
        message: "emailDomain must be a valid domain (e.g., domain.com)",
    }),
    __metadata("design:type", String)
], HostAgency.prototype, "emailDomain", void 0);
exports.HostAgency = HostAgency = __decorate([
    (0, type_graphql_1.ObjectType)("HostAgency"),
    (0, typeorm_1.Entity)("hostAgencies")
], HostAgency);
//# sourceMappingURL=HostAgency.js.map